import React from 'react'

const Payslip = () => {
  return (
    <div>Payslip</div>
  )
}

export default Payslip